import React, { ChangeEventHandler, FocusEventHandler } from "react";
import { FieldError } from "react-hook-form";
import { uniqueId } from "lodash";
import SmartContainer from "./smart-container/SmartContainer";
import { PasswordField as GenericPasswordField } from "@kaltura/mediaspace-shared-ui/form";
import { useUtilityClasses } from "./fieldClasses";
import SmartFormLabel from "./smart-form-label/SmartFormLabel";
import clsx from "clsx";

export interface Props {
    title: string;
    name: string;
    id?: string;
    readOnly?: boolean;
    required?: boolean;
    error?: FieldError;
    showErrors?: boolean;
    errorMessage?: string;
    autoComplete?: string;
    className?: string;
    onChange?: ChangeEventHandler<HTMLInputElement>;
    onBlur?: FocusEventHandler<HTMLInputElement>;
}

/**
 * password input field for site-registration form
 */
const PasswordField = React.forwardRef((props: Props, ref) => {
    const { title, id = uniqueId("input_"), required = false, className, ...rest } = props;

    const classes = useUtilityClasses();

    return (
        <SmartContainer className={clsx(classes.root, className)}>
            <SmartFormLabel htmlFor={id} className={classes.label} required={required} text={title} />
            <span className={classes.input}>
                <GenericPasswordField {...rest} id={id} required={required} ref={ref} />
            </span>
        </SmartContainer>
    );
});

export default PasswordField;
